import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChDeletePhysiotherapyMutation as useChDeletePhysiotherapyMutationType } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChDeletePhysiotherapyMutation.graphql"

const mutation = graphql`
  mutation useChDeletePhysiotherapyMutation($input: Ch_deletePhysiotherapyPrescriptionInput!) {
    ch_deletePhysiotherapyPrescription(input: $input) {
      ch_PhysiotherapyPrescription {
        id @deleteRecord
      }
    }
  }
`

const useChDeletePhysiotherapyMutation = () => {
  const [commit, isFlight] = useMutation<useChDeletePhysiotherapyMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChDeletePhysiotherapyMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChDeletePhysiotherapyMutation }
